import React, { useEffect, useState } from 'react';
import '../styles/Testimonials.css';

function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      text: "Exceptional service! My bike was delivered on time and in perfect condition. Staff was courteous and the entire process was seamless.",
      author: "Akshay",
    },
    {
      id: 2,
      text: "Had to reschedule last minute due to bus delays. Customer service was understanding and helped me modify my booking with no penalties.",
      author: "Kumar",
    },
    {
      id: 3,
      text: "Booked the wrong date by mistake. Vishwanath from customer care fixed it immediately, just an hour before the scheduled time!",
      author: "Vignesh",
    },
    {
      id: 4,
      text: "Best rental experience in Coimbatore. Easy booking, transparent pricing, and no hidden charges. Will definitely use again!",
      author: "Kavin",
    },
    {
      id: 5,
      text: "The app is super intuitive! Found exactly what I needed in seconds. Weekend trip made perfect with a well-maintained Royal Enfield.",
      author: "Nithin",
    },
    {
      id: 6,
      text: "Customer support is unmatched! Had an issue with bike and they replaced the bike for me. Impressive response time.",
      author: "Naveen",
    },
    {
      id: 7,
      text: "My go-to for bike rentals in Coimbatore. Always reliable, great fleet selection, and their new electric scooty are fantastic!",
      author: "Kiran kumar",
    },
    {
      id: 8,
      text: "Late night breakdown assistance was prompt and professional. They sent help within 30 minutes. Truly reliable service!",
      author: "Vikram",
    }
  ];

  const visibleTestimonials = testimonials.slice(startIndex, startIndex + 3);

  const handleNext = () => {
    setStartIndex((prevIndex) =>
      prevIndex + 3 >= testimonials.length ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setStartIndex((prevIndex) =>
      prevIndex - 1 < 0 ? testimonials.length - 3 : prevIndex - 1
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector('.testimonials-section');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.8) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className={`testimonials-section ${isVisible ? 'visible' : ''}`}>
      <h2 className="testimonials-title">
        What our customers have to <span className="highlight">say</span>
      </h2>

      <div className="testimonials-carousel">
        <button className="carousel-arrow prev-arrow" onClick={handlePrev}>
          &larr;
        </button>

        <div className="testimonials-container multiple">
          {visibleTestimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-card multiple ${
                index === 1 ? 'active' : ''
              }`}
            >
              <div className="quote-mark left-quote">"</div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <h4>{testimonial.author}</h4>
                <p>{testimonial.source}</p>
              </div>
              <div className="quote-mark right-quote">"</div>
            </div>
          ))}
        </div>

        <button className="carousel-arrow next-arrow" onClick={handleNext}>
          &rarr;
        </button>
      </div>
    </section>
  );
}

export default Testimonials;
